import { render, staticRenderFns } from "./giveMedici.vue?vue&type=template&id=aea53102&scoped=true"
import script from "./giveMedici.vue?vue&type=script&lang=js"
export * from "./giveMedici.vue?vue&type=script&lang=js"
import style0 from "./giveMedici.vue?vue&type=style&index=0&id=aea53102&prod&lang=less&scoped=true"
import style1 from "./giveMedici.vue?vue&type=style&index=1&id=aea53102&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea53102",
  null
  
)

export default component.exports